var _Path, _Circle, _Circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";
var SvgMusic = function SvgMusic(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-music"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M9 18V5l12-2v13"
  })), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 6,
    cy: 18,
    r: 3
  })), _Circle2 || (_Circle2 = /*#__PURE__*/React.createElement(Circle, {
    cx: 18,
    cy: 16,
    r: 3
  })));
};
export default SvgMusic;